export const OkrEN = {
    "okrAdd": "Create Okr Object"
}